import { CHANGE_EVENT, hasItem, toggleItem } from '@theme/saved-products';

/**
 * <s-saved-toggle list="wishlist|compare"> — wraps one <button> that adds or
 * removes a product from a saved list. Product data comes from the JSON in a
 * child <script type="application/json">. Labels come from data-add-label and
 * data-remove-label; the button reflects state through aria-pressed.
 */
class SSavedToggle extends HTMLElement {
  #ac;
  #button;
  #product;

  connectedCallback() {
    this.#button = this.querySelector('button');
    const json = this.querySelector('script[type="application/json"]');
    if (!this.#button || !json) return;

    try {
      this.#product = JSON.parse(json.textContent);
    } catch {
      return;
    }

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.#button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(this.list, this.#product);
    }, opts);

    window.addEventListener(CHANGE_EVENT, (event) => {
      if (event.detail?.list === this.list) this.#sync();
    }, opts);
    window.addEventListener('storage', () => this.#sync(), opts);

    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  get list() {
    return this.getAttribute('list') || 'wishlist';
  }

  #sync() {
    const active = hasItem(this.list, this.#product.id);
    this.#button.setAttribute('aria-pressed', String(active));
    const label = active ? this.dataset.removeLabel : this.dataset.addLabel;
    if (label) {
      this.#button.setAttribute('aria-label', label);
      this.#button.title = label;
    }
  }
}

if (!customElements.get('s-saved-toggle')) customElements.define('s-saved-toggle', SSavedToggle);
